module.exports = __webpack_public_path__ + "img/jv-title-logo.0cb0df14.png";